import React from 'react';
import { connect } from 'react-redux';
import { setPaymentGatewayInfo, togglePaymentGatewayPopup, toggleCliqSubMidInfoPopup, setCliqSubMidInfo } from "../../Account/AccountActions";
import CheckBox from "../CheckBox";
import { savePaymentGateways, createFabricatorSubMidId, loadSubMidData } from "../../AddNewEntity/AddNewEntityActions";

class PaymentGatewayPopup extends React.Component {

  getPaymentGatewayName = (paymentGateway) => {
    switch (paymentGateway) {
      case "authnet":
        return "Authorize.Net";
      case "paypalpro":
        return "PayPal Payments Pro";
      case "paypalstd":
        return "PayPal Payments Standard";
      case "cliqsubmid":
        return "Cliq SubMID";
      case "mxmerchant":
        return "MX Merchant";
      default:
        return ""
    }
  };

  closePopup = () => {
    this.props.togglePaymentGatewayPopup(false)
  };

  setCliqSubMidInfo = (showPopup = false) => {
    const { entityId } = this.props.accountPageInfo;
    if (entityId) {
      this.props.loadSubMidData(entityId)
        .then((res) => {
          this.props.setCliqSubMidInfo({
            cliqSubMid_CompanyName: (res && res.companyName) || '',
            cliqSubMid_ContactName: (res && res.contactName) || '',
            cliqSubMid_CorporateState: (res && res.corporateState) || '',
            cliqSubMid_CorporateType: (res && res.corporateType) || '',
            cliqSubMid_AverageTicket: (res && res.averageTicket) || '',
            cliqSubMid_FundingFrequency: (res && res.fundingFrequency) || '',
            cliqSubMid_IncorporateDate: (res && res.incorporateDate) || '',
            cliqSubMid_Industry: (res && res.industry) || '',
            cliqSubMid_MonthlyVolume: (res && res.monthlyVolume) || '',
            cliqSubMid_PhoneNumber: (res && res.phoneNumber) || '',
            cliqSubMid_TaxId: (res && res.taxId) || '',
            cliqSubMid_AccountNumber: (res && res.accountNumber) || '',
            cliqSubMid_RoutingNumber: (res && res.routingNumber) || '',
            cliqSubMid_Address_Address1: (res && res.address && res.address.address1) || '',
            cliqSubMid_Address_Address2: (res && res.address && res.address.address2) || '',
            cliqSubMid_Address_CityTown: (res && res.address && res.address.cityTown) || '',
            cliqSubMid_Address_CountryCode: (res && res.address && res.address.countryCode) || '',
            cliqSubMid_Address_PostalCode: (res && res.address && res.address.postalCode) || '',
            cliqSubMid_Address_StateProvince: (res && res.address && res.address.stateProvince) || '',
            cliqSubMid_Owners_DOB: (res && res.owners && res.owners.dob) || '',
            cliqSubMid_Owners_Email: (res && res.owners && res.owners.email) || '',
            cliqSubMid_Owners_FirstName: (res && res.owners && res.owners.firstName) || '',
            cliqSubMid_Owners_FullName: (res && res.owners && res.owners.fullName) || '',
            cliqSubMid_Owners_LastName: (res && res.owners && res.owners.lastName) || '',
            cliqSubMid_Owners_MiddleName: (res && res.owners && res.owners.middleName) || '',
            cliqSubMid_Owners_PhoneNumber: (res && res.owners && res.owners.phoneNumber) || '',
            cliqSubMid_Owners_DriverLicenseNumber: (res && res.owners && res.owners.driverLicenseNumber) || '',
            cliqSubMid_Owners_DriverLicenseState: (res && res.owners && res.owners.driverLicenseState) || '',
            cliqSubMid_Owners_SSN: (res && res.owners && res.owners.ssn) || '',
            cliqSubMid_Owners_OwnershipPercentage: (res && res.owners && res.owners.ownershipPercentage) || '',
            cliqSubMid_Owners_Address_Address1: (res && res.owners && res.owners[0].address && res.owners[0].address.address1) || '',
            cliqSubMid_Owners_Address_Address2: (res && res.owners && res.owners[0].address && res.owners[0].address.address2) || '',
            cliqSubMid_Owners_Address_CityTown: (res && res.owners && res.owners[0].address && res.owners[0].address.cityTown) || '',
            cliqSubMid_Owners_Address_CountryCode: (res && res.owners && res.owners[0].address && res.owners[0].address.countryCode) || '',
            cliqSubMid_Owners_Address_PostalCode: (res && res.owners && res.owners[0].address && res.owners[0].address.postalCode) || '',
            cliqSubMid_Owners_Address_StateProvince: (res && res.owners && res.owners[0].address && res.owners[0].address.stateProvince) || ''
          });
          this.props.toggleCliqSubMidInfoPopup(showPopup)
        });
    }
  }

  savePaymentGateways = () => {
    const { entityId } = this.props.accountPageInfo;
    const { paymentGateway_MxMerchant_MerchantId,
      paymentGateway_MxMerchant_ApiKey,
      paymentGateway_MxMerchant_ApiSecret,
      paymentGateway_MxMerchant_NachaId,
      paymentGateway_MxMerchant_TestMode,
      paymentGateway_AuthNet_ApiLogin, paymentGateway_AuthNet_NachaId, paymentGateway_AuthNet_TransactionKey, paymentGateway_AuthNet_TestMode,
      paymentGateway_AuthNet_CustomEndpointUrl, paymentGateway_Cliq_GatewayId, paymentGateway_Cliq_ServiceKey, paymentGateway_Cliq_DistributorSubMid, paymentGateway_Cliq_FabricatorSubMid } = this.props.paymentGatewayInfo;
    let paymentGateways = {
      fabricatorId: entityId,
      authorizeNet: {
        apiLoginId: paymentGateway_AuthNet_ApiLogin,
        transactionKey: paymentGateway_AuthNet_TransactionKey,
        nachaId: paymentGateway_AuthNet_NachaId,
        testMode: paymentGateway_AuthNet_TestMode,
        customEndpointUrl: paymentGateway_AuthNet_CustomEndpointUrl
      },
      cliq: {
        gatewayId: paymentGateway_Cliq_GatewayId,
        serviceKey: paymentGateway_Cliq_ServiceKey,
        distributorSubMid: paymentGateway_Cliq_DistributorSubMid,
        fabricatorSubMid: paymentGateway_Cliq_FabricatorSubMid
      },
      mxMerchant: {
        merchantId: paymentGateway_MxMerchant_MerchantId,
        apiKey: paymentGateway_MxMerchant_ApiKey,
        apiSecret: paymentGateway_MxMerchant_ApiSecret,
        nachaId: paymentGateway_MxMerchant_NachaId,
        testMode: paymentGateway_MxMerchant_TestMode,
      }
    };
    this.props.savePaymentGateways(paymentGateways).then((res) => res && this.closePopup());
  }

  createFabricatorSubMidId = () => {
    const { entityId } = this.props.accountPageInfo;

    this.props.createFabricatorSubMidId(entityId).then((res) => { this.props.setPaymentGatewayInfo({ paymentGateway_Cliq_FabricatorSubMid: res }); });
  }

  renderStoreSubMIDIdList(storeSubMidIds) {

  }

  render() {

    const { paymentGatewayManaging,
      paymentGateway_MxMerchant_MerchantId,
      paymentGateway_MxMerchant_ApiKey,
      paymentGateway_MxMerchant_ApiSecret,
      paymentGateway_MxMerchant_NachaId,
      paymentGateway_MxMerchant_TestMode,
      paymentGateway_AuthNet_ApiLogin, paymentGateway_AuthNet_NachaId, paymentGateway_AuthNet_TransactionKey,
      paymentGateway_AuthNet_TestMode, paymentGateway_Cliq_GatewayId, paymentGateway_Cliq_ServiceKey, paymentGateway_Cliq_DistributorSubMid, paymentGateway_Cliq_FabricatorSubMid } = this.props.paymentGatewayInfo;

    return (
      <div className="ui-popup">
        <div className="ui-popup-header">
          <span className="ui-popup-header__text">Payment Gateways</span>
          <button className="ui-popup-header__close" onClick={this.closePopup} />
        </div>
        <div className="ui-popup-body ui-popup-body--tiny">
          <ul className="manage-payment-gateways">
            {["mxmerchant", "authnet", "paypalpro", "paypalstd", "cliqsubmid"].map((paymentGateway) => {
              if (paymentGateway === "paypalpro" || paymentGateway === "paypalstd") { //TODO[Eugen] finish logic for these ones
                return null
              }
              return (
                <li onClick={() => this.props.setPaymentGatewayInfo({ paymentGatewayManaging: paymentGateway })}
                  key={paymentGateway}
                  className={"manage-payment-gateways-listItem"
                    + (paymentGatewayManaging === paymentGateway ? " manage-payment-gateways-listItem--selected" : "")}>
                  {this.getPaymentGatewayName(paymentGateway)}
                </li>
              )
            })}
          </ul>
          <div className="manage-payment-gateways--gateway">
            {paymentGatewayManaging === "mxmerchant" ? (
              <div>
                <label>Merchant Id</label>
                <input type="text" value={paymentGateway_MxMerchant_MerchantId} placeholder="Identificator of Merchant"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_MxMerchant_MerchantId: e.target.value })} />
                <label>API KEY</label>
                <input type="text" value={paymentGateway_MxMerchant_ApiKey} placeholder="Api Key"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_MxMerchant_ApiKey: e.target.value })} />
                <label>API SECRET</label>
                <input type="text" value={paymentGateway_MxMerchant_ApiSecret} placeholder="Api Secret"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_MxMerchant_ApiSecret: e.target.value })} />
                <label>NACHA ID</label>
                <input type="text" value={paymentGateway_MxMerchant_NachaId} placeholder="NACHA Identificator"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_MxMerchant_NachaId: e.target.value })} />
                <CheckBox checked={paymentGateway_MxMerchant_TestMode}
                  text="Test Mode (use developer sandbox api endpoint)"
                  onChecked={() => this.props.setPaymentGatewayInfo({ paymentGateway_MxMerchant_TestMode: !paymentGateway_MxMerchant_TestMode })} />
              </div>
            ) : null}
            {paymentGatewayManaging === "authnet" ? (
              <div>
                <label>API Login</label>
                <input type="text" value={paymentGateway_AuthNet_ApiLogin} maxLength={12} placeholder="Auth.NET API Key"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_AuthNet_ApiLogin: e.target.value })} />
                <label>Transaction Key</label>
                <input type="text" value={paymentGateway_AuthNet_TransactionKey} maxLength={16} placeholder="Auth.NET Transaction Key"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_AuthNet_TransactionKey: e.target.value })} />
                <label>NACHA ID</label>
                <input type="text" value={paymentGateway_AuthNet_NachaId} maxLength={10} placeholder="NACHA Identificator"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_AuthNet_NachaId: e.target.value })} />
                <CheckBox checked={paymentGateway_AuthNet_TestMode}
                  text="Test Mode (use developer sandbox api endpoint)"
                  onChecked={() => this.props.setPaymentGatewayInfo({ paymentGateway_AuthNet_TestMode: !paymentGateway_AuthNet_TestMode })} />
              </div>
            ) : null}
            {paymentGatewayManaging === "cliqsubmid" ? (
              <div>
                <label>Gateway Id</label>
                <input type="text" value={paymentGateway_Cliq_GatewayId} maxLength={12} placeholder="Gateway Id"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_Cliq_GatewayId: e.target.value })} />
                <label>Service Key</label>
                <input type="text" value={paymentGateway_Cliq_ServiceKey} maxLength={12} placeholder="Service Key"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_Cliq_ServiceKey: e.target.value })} />
                <label>Distributor SubMID Id</label>
                <input type="text" value={paymentGateway_Cliq_DistributorSubMid} maxLength={12} placeholder="Distributor SubMid Id"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_Cliq_DistributorSubMid: e.target.value })} />
                <label>Fabricator SubMID Id</label>
                <input type="text" value={paymentGateway_Cliq_FabricatorSubMid} maxLength={12} placeholder="Fabricator SubMid Id"
                  onChange={(e) => this.props.setPaymentGatewayInfo({ paymentGateway_Cliq_FabricatorSubMid: e.target.value })} />

                <button className="ui-button ui-button--blue" onClick={this.setCliqSubMidInfo}>
                  <span className="ui-button-text ui-button--uppercase">Request a SubMID Id</span>
                </button>

              </div>
            ) : null}
          </div>
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button ui-button--blue" onClick={this.closePopup}>
            <span className="ui-button-text ui-button--uppercase">Cancel</span>
          </button>
          <button className="ui-button ui-button--green" onClick={this.savePaymentGateways}>
            <span className="ui-button-text ui-button--uppercase">Save</span>
          </button>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    paymentGatewayInfo: store.accountState.paymentGatewayInfo,
    accountPageInfo: store.accountState.accountPageInfo
  };
};

const mapDispatchToProps = {
  setPaymentGatewayInfo,
  savePaymentGateways,
  createFabricatorSubMidId,
  togglePaymentGatewayPopup,
  toggleCliqSubMidInfoPopup,
  loadSubMidData,
  setCliqSubMidInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentGatewayPopup);
